<div class="flex flex-col h-full overflow-hidden p-4">
  <div class="flex justify-endX">
    <div>
      <p-button
        label="Excel"
        icon="pi pi-file-export"
        (click)="exportExcel()"></p-button>
        <div class="font-bold valordate">Valørdato: {{ valorDate() }}</div>
    </div>
  </div>
  <div class="h-full overflow-hidden">
    <p-tabs [value]="activeTab()" class="h-full overflow-hidden">
      <p-tablist class="h-20">
        @for (tab of tabs(); track tab.tabIndex) {
          <p-tab [value]="tab.tabIndex">{{ tab.tabName }}</p-tab>
        }
      </p-tablist>
      <p-tabpanels class="h-full overflow-hidden">
        @for (tab of tabs(); track tab.tabIndex) {
          <p-tabpanel [value]="tab.tabIndex" class="h-full overflow-hidden">
            <app-konvertering-datagrid
              [data]="tab.tabData"
              class="h-full overflow-hidden" />
          </p-tabpanel>
        }
      </p-tabpanels>
    </p-tabs>
  </div>
</div>
